import { EventCategoryEnum, EventEnum } from "@/v2/enum/events";
import { IAnalytics } from "@/plugins/analytics/types";
import {
  analyticsEventCommonData,
  trackEvent,
} from "@/v2/util/analytics/trackEvent";

export function paymentLinkTrack(
  analytics: IAnalytics,
  eventName: EventEnum,
  businessId: string,
  additionalData: Record<string, any> = {}
): void {
  trackEvent({
    eventCategory: EventCategoryEnum.PAYMENT_LINK,
    analytics,
    eventName,
    additionalData: {
      ...analyticsEventCommonData([["business", businessId]]),
      ...additionalData,
    },
  });
}
